import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import cx from 'classnames'

import { MANUAL_URL, LOCALE_PREFIX } from './constants'

import hocConnect from './hocConnect'

import './style.scss'

@hocConnect
export default class Importer extends Component {
    static propTypes = {
        downloadImporter: PropTypes.func.isRequired,
        id: PropTypes.string.isRequired,
        isDownloading: PropTypes.bool.isRequired,
    }

    onDownloadButtonClick = () => {
        const { id, isDownloading, downloadImporter } = this.props

        if (!isDownloading) downloadImporter(id)
    }

    render() {
        const { isDownloading } = this.props

        return (
            <div className={'content-importer'}>
                <div className={'title border'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.importer.title`} />
                </div>
                <div className={'text'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.importer.info.intro`} />
                </div>
                <ul className={'list'}>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.info.upload`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.info.export`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.info.background`} />
                    </li>
                </ul>
                <div className={'title'}>
                    <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.title`} />
                </div>
                <ul className={'list'}>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.win`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.java`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.excel`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.rootRights`} />
                    </li>
                    <li className={'item'}>
                        <FormattedMessage id={`${LOCALE_PREFIX}.importer.requirement.hdd`} />
                    </li>
                </ul>
                <div
                    className={cx('download-button', isDownloading && 'disabled')}
                    onClick={this.onDownloadButtonClick}
                >
                    <FormattedMessage id={`${LOCALE_PREFIX}.button`} />
                </div>
                <div className={'manual'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.manual`}
                        values={{
                            a: (chunks) => (
                                <a href={MANUAL_URL} target="_blank" rel="noopener noreferrer">
                                    {chunks}
                                </a>
                            ),
                        }}
                    />
                </div>
                <div className={'help'}>
                    <FormattedMessage
                        id={`${LOCALE_PREFIX}.help`}
                        values={{
                            atel: (chunks) => <a href="tel:+420 274 000 800">{chunks}</a>,
                            amail: (chunks) => <a href="mailto:podpora.cz@dnb.com&subject=Gnosus importér">{chunks}</a>,
                        }}
                    />
                </div>
            </div>
        )
    }
}
